export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_ACTIVATION_EMAIL = 'SET_ACTIVATION_EMAIL';
export const SET_IS_RESTRICTED_USER = 'SET_IS_RESTRICTED_USER';
export default SET_USER_INFO;
